import app from '@/main'
import { get } from '@/utils/ajax'
import { loginEvent } from '@/utils/sensor'
import { colorRgb, create_cookie, read_cookie } from '@/utils/utils'

export default {
  // 获取学校数据
  async getSchoolInfo({ state, commit }) {
    // 仅老师、教管有审核状态
    if (![10001, 10002].includes(state.user.role_id) || !state.user.unit_id) return
    const data = await get('/edu/zone/school/info', { unitId: state.user.unit_id })
    commit('SET_SCHOOL_INFO', data)
  },
  // 获取最新学校审核消息
  async getMessageLast({ state, commit }) {
    // 仅老师、教管有审核状态
    if (![10001, 10002].includes(state.user.role_id)) return
    const res = await get('/edu/zone/invite/school/audit/message/latest')
    if (res) {
      commit('SET_LAST_MESSAGE', res)
    } else {
      commit('SET_LAST_MESSAGE', null)
    }
  },
  // 检查是否跳过个人信息展示提示完善信息模态框
  async handleCheckSkipModal({ state, commit }, payload) {
    // 仅老师、教管有审核状态
    const { skipStatus } = state.user
    if (skipStatus) {
      this.dispatch('eduCommonReport', {
        key: 'clickInvalidBtn',
        ...payload
      })
      commit('SET_SKIP_MODAL', true)
      return false
    } else {
      commit('SET_LAST_MESSAGE', false)
      return true
    }
  },
  // 获取最新学校审核消息
  async getGradeList({ state, commit }) {
    if (state.gradeList.length) return
    const data = await get(`/edu/zone/school/open/grade/list`)
    if (data && data.length) {
      commit('SET_GRADE_LIST', data)
    } else {
      commit('SET_GRADE_LIST', [])
    }
  },
  // 获取最新教师资格证号
  async getTeacherCardNumber({ state, commit }) {
    const data = await get('/api/home/account')
    if (data) {
      commit('SET_USER', data)
    }
  },
  // 获取b端的用户信息
  async getClassUserInfo({ state, commit }, payload) {
    const user = await get('/edu/zone', {}, { ignoreMsg: payload && payload.ignoreMsg })
    // 如果是体验教师则跳转到补充信息页
    if (user.unit_id === -1) {
      window.location.replace(CONFIG.school + '/addTeacherInfo')
    }
    commit('SET_USER', user)
    return state.user
  },
  // 获取用户是否已经完善信息
  async getHasCompleteMsg({ state, commit }) {
    const data = await get('/edu/zone/login/teacher/info/improve/skip')
    const _data = { skipStatus: data.skipStatus }
    commit('SET_USER', _data)
    return state.user
  },
  // 获取用户手机号
  async getUserRealPhone({ state, commit }, payload) {
    // const data = await get('/edu/zone/user/phone')
    // const _data = { realPhone: data.phone }
    // commit('SET_USER', _data)
    // return state.user
  },
  // 获取c端的用户信息
  async getCodemaoUserInfo({ state, commit }) {
    const user = await app.$auth('get_profile')
    loginEvent(user)
    commit('SET_USER', user)
    return state.user
  },
  // 获取c端的用户信息(私密信息)
  async getCodemaoAuthUserInfo({ state, commit }) {
    const user = await app.$auth('get_auth')
    user.phone = user.phone_number
    commit('SET_USER', user)
    return state.user
  },
  async logout({ commit }) {
    await app.$auth('logout')
    commit('LOGOUT')
    create_cookie('classroomLogin', '', -1) // 删除
  },
  // 上报用户成功进入点猫编程平台情形
  // 1. 用户在不退出的情况下第二天打开点猫编程平台，也算一次活跃
  // 2. 用户在一天内n次退出点猫编程平台再登录成功进入点猫编程平台，就算n次活跃
  async reportClassroomLogin({
    state: {
      user: { id, province_id, city_id, district_id, unit_id, unit_name, role_id, unit_type_id }
    },
    commit
  }) {
    const oldId = read_cookie('classroomLogin')
    if (!oldId || +oldId !== id) {
      create_cookie('classroomLogin', id, 1, true)
      window.caReport.add_event({
        key: 'classroom_login',
        segmentation: {
          province: province_id,
          city: city_id,
          district: district_id,
          unit_id,
          unit_name,
          type: unit_type_id,
          user_id: id,
          role_id,
          platform: 'web',
          special_channel: localStorage.getItem('channel')
        }
      })
    }
  },
  // 新的上报用户成功进入点猫编程平台情形
  async reportStart({ state }) {
    window.caReport.add_event({
      key: 'start',
      segmentation: {
        user_id: state.user.id,
        channel: document.referrer || '',
        platform: 'web'
      }
    })
  },
  // 点猫编程平台页面访问情况
  async reportClassroomPageVisit({
    state: {
      user: { id, province_id, city_id, district_id, unit_id, unit_name, role_id, unit_type_id }
    }
  }) {
    window.caReport.add_event({
      key: 'classroom_page_visit',
      segmentation: {
        province: province_id,
        city: city_id,
        district: district_id,
        unit_id,
        unit_name,
        type: unit_type_id,
        user_id: id,
        role_id,
        platform: 'web',
        page:
          window.location.href.indexOf('?') !== -1
            ? window.location.href.split('?')[0]
            : window.location.href
      }
    })
  },
  // 工具下载量
  async reportToolsDownload(
    {
      state: {
        user: { id, province_id, city_id, district_id, unit_id, unit_name, role_id, unit_type_id }
      }
    },
    playload
  ) {
    window.caReport.add_event({
      key: 'download',
      segmentation: {
        province: province_id,
        city: city_id,
        district: district_id,
        unit_id,
        unit_name,
        type: unit_type_id,
        user_id: id,
        role_id,
        platform: 'web',
        tool: playload
      }
    })
  },
  // 课程开通情况
  async reportPackagesUse({
    state: {
      user,
      courseManage: { courseInfo }
    }
  }) {
    const { id, province_id, city_id, district_id, unit_id, unit_name, role_id, unit_type_id } =
      user || {}
    window.caReport.add_event({
      key: 'packages_use',
      segmentation: {
        province: province_id,
        city: city_id,
        district: district_id,
        unit_id,
        unit_name,
        type: unit_type_id,
        package_id: courseInfo.id,
        user_id: id,
        role_id
      }
    })
  },
  // 上报申请单位
  async reportClassroomApplication({
    state: {
      common: { provinceInfo, cityInfo, districtInfo },
      customization: { applyInfo }
    },
    commit
  }) {
    window.caReport.add_event({
      key: 'classroom_application',
      segmentation: {
        province: provinceInfo.id,
        city: cityInfo.id,
        district: districtInfo.id,
        unit_id: applyInfo.unitId,
        unit_name: applyInfo.school,
        type: applyInfo.unitType,
        special_channel:
          window.location.href.indexOf('?') !== -1
            ? window.location.href.split('?')[0]
            : window.location.href
      }
    })
  },
  // 按钮点击事件上报生成热力图
  async reportElementClick({ state, commit }, playload) {
    const { province_id, city_id, district_id, role_id } = state.user || {}
    window.caReport.add_event({
      key: 'landpage_click',
      segmentation: {
        province: province_id,
        city: city_id,
        district: district_id,
        role_id,
        utm_source: document.referrer || '', // 来源
        page: location.host + location.pathname, // 域名网址
        // element_id: playload.element_id, // data-buried的名字
        selector: playload.wid // 组件的综合名字，用于定位element
      }
    })
  },
  // 上报页面点击
  reportPageClick({ state }, payload) {
    const user = state.user || {}
    window.caReport.add_event({
      key: 'PAGE_CLICK',
      segmentation: {
        user_id: user.id || 0,
        selector: payload.wid,
        selector_text: payload.text,
        path: location.pathname
      }
    })
  },
  // 设置上报用户画像
  reportUserDetail({ state }) {
    const { realPhone, ...user } = state.user || {}
    window.caReport.get_user_detail({ user_id: user.id || 0, ...user })
  },
  startPageSession() {
    window.caReport.start_event('PAGE_SESSION')
  },
  // 上报页面浏览时长
  reportPageSession({ state }, payload) {
    const user = state.user || {}
    window.caReport.end_event({
      key: 'PAGE_SESSION',
      segmentation: {
        user_id: user.id || 0,
        path: payload
      }
    })
  },
  // 上报页面浏览
  reportPageView({ state }, payload) {
    const user = state.user || {}
    window.caReport.add_event({
      key: 'PAGE_VIEW',
      segmentation: {
        user_id: user.id || 0,
        path: payload
      }
    })
  },
  startIndexToPlayVideo() {
    window.caReport.start_event('INDEX_TO_PLAY_VIDEO')
  },
  // 上报首页到点击课程包详情页视频播放按钮时间
  reportIndexToPlayVideo({ state }) {
    const user = state.user || {}
    window.caReport.end_event({
      key: 'INDEX_TO_PLAY_VIDEO',
      segmentation: {
        user_id: user.id || 0
      }
    })
  },
  // 设置视频播放时长
  reportVideoPlayTime({ state }, payload) {
    const user = state.user || {}
    window.caReport.add_event({
      key: 'VIDEO_PLAY_TIME',
      segmentation: {
        user_id: user.id || 0,
        duration: payload.duration,
        play_duration: payload.play_duration,
        lesson_id: payload.lesson_id,
        package_id: payload.package_id
      }
    })
  },
  // 记录用户点击播放按钮
  reportClickVideoPlayBtn({ state }) {
    const user = state.user || {}
    window.caReport.add_event({
      key: 'CLICK_VIDEO_PLAY_BTN',
      segmentation: {
        user_id: user.id || 0
      }
    })
  },
  // 记录用户点击创作工具
  reportClickTool({ state }) {
    const user = state.user || {}
    window.caReport.add_event({
      key: 'CLICK_TOOL',
      segmentation: {
        user_id: user.id || 0,
        path: location.pathname
      }
    })
  },
  // 埋点收集的通用方法
  eduCommonReport({ state }, { key = 'nokey', ...arg }) {
    const { id = 0, role_id = 0, fullName = '' } = state.user
    window.caReport.add_event({
      key,
      segmentation: {
        user_id: id,
        role_id,
        fullName,
        ...arg
      }
    })
  },
  // 主动修改主题色
  changeThemeColor({ state }, { themeColor }) {
    document.documentElement.style.setProperty(
      '--primary-color-source',
      colorRgb(themeColor || '#00c4aa') // 默认主题色 #00c4aa
    )
    document.documentElement.style.setProperty(
      '--primary-color',
      'rgba(var(--primary-color-source), 1)'
    )

    document.documentElement.style.setProperty(
      '--primary-el-color-source',
      colorRgb(themeColor || '#FFA21C') // 默认elment相关按钮主题色 #ffc81d
    )
    document.documentElement.style.setProperty(
      '--primary-el-color',
      'rgba(var(--primary-el-color-source), 1)'
    )
  }
}
